<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col cols="8">
          <b-card>
            <b-row>
              <b-col class="mb-2">
                <b-badge :variant="statusVariant(this.form.status)">
                  <span v-if="this.form.status === 0">{{
                    form.status_name
                  }}</span>
                  <span v-else-if="this.form.status === 1">{{
                    form.status_name
                  }}</span>
                  <span v-else-if="this.form.status === 2">{{
                    form.status_name
                  }}</span>
                  <span v-else-if="this.form.status === 3">{{
                    form.status_name
                  }}</span>
                  <span v-else-if="this.form.status === 4">{{
                    form.status_name
                  }}</span>
                </b-badge>
              </b-col>
              <b-col cols="6" class="text-right mb-2 font-weight-bolder">
                <router-link
                  v-bind:to="{
                    path: '/procurement/purchase/' + id + '/invoice',
                  }"
                  class="text-primary"
                >
                  Detail Invoice
                  <feather-icon class="mr-0" icon="ChevronRightIcon" />
                </router-link>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label class="h6">Purchase Code</label>
              </b-col>
              <b-col>
                <span class="font-weight-bolder float-right">{{
                  form.code
                }}</span>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <label class="h6">Date</label>
              </b-col>
              <b-col>
                <span class="font-weight-bolder float-right">{{
                  moment(form.date)
                }}</span>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Details</label
            >
            <b-row>
              <b-col cols="8">
                <b-form-group label="Vendor" label-for="vendor">
                  <v-select
                    id="vendor"
                    v-model="form.selectedVendor"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsVendor"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedVendor"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedVendor }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Is Warehouse" label-for="is_warehouse">
                  <v-select
                    id="is_warehouse"
                    v-model="form.selectedIsWarehouse"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsIsWarehouse"
                    placeholder="Is Warehouse"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedIsWarehouse"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedIsWarehouse }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" v-if="form.stateIsWarehouse === 1">
                <b-form-group label="Warehouse" label-for="warehouse">
                  <v-select
                    id="warehouse"
                    v-model="form.selectedWarehouse"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsWarehouse"
                    placeholder="Warehouse"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedWarehouse"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedWarehouse }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <label for="items" class="mb-1" v-if="this.form.file1 !== null"
              >Attachment</label
            >
            <b-row>
              <b-col>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  pill
                  v-if="this.form.file1 !== null"
                  @click="link(form.file1)"
                >
                  Attachment 1
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  pill
                  v-if="this.form.file2 !== null"
                  @click="link(form.file2)"
                >
                  Attachment 2
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  pill
                  v-if="this.form.file3 !== null"
                  @click="link(form.file3)"
                >
                  Attachment 3
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  pill
                  v-if="this.form.file4 !== null"
                  @click="link(form.file4)"
                >
                  Attachment 4
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="mr-1"
                  pill
                  v-if="this.form.file5 !== null"
                  @click="link(form.file5)"
                >
                  Attachment 5
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Shipping</label
            >
            <b-row>
              <b-col md="6">
                <b-form-group label="Shipping Date" label-for="shipping_date">
                  <flat-pickr
                    id="shipping_date"
                    v-model="form.shipping_date"
                    class="form-control"
                    placeholder="Shipping Date"
                  />
                  <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                  <!-- <p>Value: '{{ form.shipping_date }}'</p> -->
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Shipping Address"
                  label-for="shipping_address"
                >
                  <b-form-textarea
                    id="shipping_address"
                    placeholder="Shipping Address"
                    v-model="form.shipping_address"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Payment Info</label
            >
            <b-form-group label="Account" label-for="Account">
              <v-select
                id="Account"
                v-model="form.selectedAccount"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsAccount"
                placeholder="Select 1 Account"
                disabled
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedAccount"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedVendor }}</strong> -->
            </b-form-group>
            <hr class="my-2" />
            <b-form-group label="Tax" label-for="tax">
              <cleave
                id="tax"
                placeholder="Tax"
                v-model="form.tax"
                class="form-control"
                :raw="false"
                :options="options.number"
                :disabled="form.status === 0 ? false : true"
                required
              />
            </b-form-group>
            <b-form-group label="Additional Cost" label-for="additional_cost">
              <cleave
                id="additional_cost"
                placeholder="Additional Cost"
                v-model="form.additional_cost"
                class="form-control"
                :raw="false"
                :options="options.number"
                :disabled="form.status === 0 ? false : true"
                required
              />
            </b-form-group>
            <b-form-group label="Total Price" label-for="total_price">
              <cleave
                id="total_price"
                placeholder="Total Price"
                v-model="form.total_price"
                class="form-control"
                :raw="false"
                :options="options.number"
                disabled
              />
            </b-form-group>
            <hr class="my-2" />
            <b-form-group label="Term Payment" label-for="term_payment">
              <v-select
                id="term_payment"
                v-model="form.selectedTermPayment"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsTermPayment"
                placeholder="Select 1 Term Payment"
                disabled
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedTermPayment"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedTermPayment }}</strong> -->
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <label class="mb-1 text-primary font-weight-bold"
              >Purchase Items</label
            >
            <b-row>
              <b-col>
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                  <b-form-group>
                    <div class="d-flex align-items-center">
                      <label class="mr-1">Search</label>
                      <b-form-input
                        v-model="searchTerm"
                        placeholder="Search"
                        type="text"
                        class="d-inline-block"
                      />
                    </div>
                  </b-form-group>
                </div>
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                            :src="props.row.avatar"
                                            class="mx-1"
                                        /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">{{
                        formatRupiah(props.row.price)
                      }}</span>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            v-b-modal.modal-lg
                            @click="openItemDetails(props.row.value)"
                            v-if="
                              permissions.includes(
                                'procurement-purchase-item-detail'
                              )
                            "
                          >
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>Detail</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
                <!-- Modal -->
                <b-modal
                  id="modal-lg"
                  ok-only
                  ok-title="Ok"
                  centered
                  size="lg"
                  title="Large Modal"
                >
                  <b-row>
                    <b-col md="12">
                      <b-row>
                        <b-col md="3">
                          <b-row>
                            <b-col md="12">
                              <b-form-group
                                label="Image"
                                label-for="product_image"
                              >
                                <img
                                  :src="detail.product_image"
                                  fluid
                                  alt="product image"
                                  width="100%"
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="9">
                          <b-row>
                            <b-col md="6">
                              <b-form-group
                                label="Code"
                                label-for="purchase_code"
                              >
                                <b-form-input
                                  id="purchase_code"
                                  placeholder="Code"
                                  v-model="detail.purchase_code"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group
                                label="Product"
                                label-for="product_name"
                              >
                                <b-form-input
                                  id="product_name"
                                  placeholder="Product"
                                  v-model="detail.product_name"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Qty" label-for="qty">
                                <cleave
                                  id="qty"
                                  placeholder="Qty"
                                  v-model="detail.qty"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.number"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Unit" label-for="unit_name">
                                <b-form-input
                                  id="unit_name"
                                  placeholder="Unit"
                                  v-model="detail.unit_name"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Price" label-for="price">
                                <cleave
                                  id="price"
                                  placeholder="Price"
                                  v-model="detail.price"
                                  class="form-control"
                                  :raw="false"
                                  :options="options.number"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mb-1"
            block
            @click="validation()"
            v-if="
              permissions.includes('procurement-purchase-update') &&
              form.status <= 0
            "
          >
            Update
          </b-button>
        </b-col>
        <b-col cols="6">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mb-1"
            block
            @click="deletePurchase()"
            v-if="
              permissions.includes('procurement-purchase-delete') &&
              form.status <= 0
            "
          >
            Delete
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1"
            block
            @click="submitStatus()"
            v-if="
              permissions.includes('procurement-purchase-update') &&
              form.status === 0
            "
          >
            Submit
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            block
            v-b-modal.modal-process
            v-if="
              permissions.includes('procurement-purchase-update') &&
              form.status === 1
            "
          >
            Process
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1"
            block
            @click="statusReceive()"
            v-if="
              permissions.includes('procurement-purchase-update') &&
              form.status === 2
            "
          >
            Receive
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BModal,
  VBModal,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BModal,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      id: null,
      form: {
        code: "",
        date: null,
        selectedVendor: null,
        optionsVendor: [],
        total_price: 0,
        tax: 0,
        additional_cost: 0,
        file1: null,
        file2: null,
        file3: null,
        file4: null,
        file5: null,
        selectedAccount: null,
        optionsAccount: [],
        description: "",
        shipping_address: "",
        shipping_date: null,
        selectedTermPayment: null,
        optionsTermPayment: [],
        selectedIsWarehouse: null,
        optionsIsWarehouse: [
          { value: 0, text: "No" },
          { value: 1, text: "Yes" },
        ],
        selectedWarehouse: null,
        optionsWarehouse: [],
        stateIsWarehouse: null,
        status: "",
        status_name: "",
        defaultTotalPrice: null,
      },
      form2: {
        purchase_id: null,
        selectedProduct: null,
        optionsProduct: [],
        qty: null,
        price: null,
      },
      detail: {
        id: null,
        product_image: "",
        product_id: null,
        purchase_code: "",
        product_name: "",
        qty: null,
        unit_name: "",
        price: null,
        purchase_id: null,
      },
      process: {
        amount: null,
        selectedTermPayment: null,
        optionsTermPayment: [],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      numberAttachment: 0,
      hasImage: "",
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Price",
          field: "price",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      permissions: [],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-warning",
        1: "light-info",
        2: "light-primary",
        3: "light-success",
        4: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  watch: {
    "form.tax": function ($data) {
      if ($data === "") {
        this.form.tax = 0;
      } else {
        this.triggerTax($data);
      }
    },
    "form.additional_cost": function ($data) {
      if ($data === "") {
        this.form.additional_cost = 0;
      } else {
        this.triggerAdditionalCost($data);
      }
    },
    "form.selectedIsWarehouse": function ($data) {
      this.form.stateIsWarehouse = $data.value;
    },
  },
  created() {
    this.getID();
    this.getAllPermissions();
    this.getDetails();
    this.getPurchaseItems();
    this.getVendor();
    this.getProduct();
    this.getTermPayment();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getID() {
      this.id = this.$route.params.id;
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("procurement/purchase/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.defaultTotalPrice =
          response.data.data.total_price -
          response.data.data.tax -
          response.data.data.additional_cost;
        this.form.code = response.data.data.code;
        this.form.date = response.data.data.created_at;
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.selectedVendor = {
          value: response.data.data.vendor_id,
          text: response.data.data.vendor_name,
        };
        this.form.total_price = response.data.data.total_price;
        this.form.tax = response.data.data.tax;
        this.form.additional_cost = response.data.data.additional_cost;
        this.form.selectedAccount = {
          value: response.data.data.account_id,
          text: response.data.data.account_name,
        };
        this.form.description = response.data.data.description;
        this.form.shipping_address = response.data.data.shipping_address;
        this.form.shipping_date = response.data.data.shipping_date;
        this.form.selectedTermPayment = {
          value: response.data.data.term_payment,
          text: response.data.data.term_payment_name,
        };
        if (response.data.data.is_warehouse === 1) {
          this.form.selectedIsWarehouse = {
            value: response.data.data.is_warehouse,
            text: "Yes",
          };
        } else {
          this.form.selectedIsWarehouse = {
            value: response.data.data.is_warehouse,
            text: "No",
          };
        }
        this.form.selectedWarehouse = {
          value: response.data.data.warehouse_id,
          text: response.data.data.warehouse_name,
        };
        const { baseUrl } = $themeConfig.app;
        if (response.data.data.attachment_1 !== null) {
          this.form.file1 = baseUrl;
          this.form.file1 += "storage/procurement/purchase/";
          this.form.file1 += response.data.data.attachment_1;
        }
        if (response.data.data.attachment_2 !== null) {
          this.form.file2 = baseUrl;
          this.form.file2 += "storage/procurement/purchase/";
          this.form.file2 += response.data.data.attachment_2;
        }
        if (response.data.data.attachment_3 !== null) {
          this.form.file3 = baseUrl;
          this.form.file3 += "storage/procurement/purchase/";
          this.form.file3 += response.data.data.attachment_3;
        }
        if (response.data.data.attachment_4 !== null) {
          this.form.file4 = baseUrl;
          this.form.file4 += "storage/procurement/purchase/";
          this.form.file4 += response.data.data.attachment_4;
        }
        if (response.data.data.attachment_5 !== null) {
          this.form.file5 = baseUrl;
          this.form.file5 += "storage/procurement/purchase/";
          this.form.file5 += response.data.data.attachment_5;
        }
      });
    },
    getPurchaseItems() {
      const id = this.$route.params.id;
      this.$http
        .get("procurement/purchases/" + id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          const { baseUrl } = $themeConfig.app;
          for (i = 0; i < datas.length; i++) {
            this.photo = baseUrl;
            this.photo += "storage/product/";
            this.photo += datas[i].product_image;
            // console.log(this.photo)
            var $data = {
              value: datas[i].id,
              image: this.photo,
              code: datas[i].purchase_code,
              name: datas[i].product_name,
              qty: datas[i].qty,
              unit_name: datas[i].unit_name,
              price: datas[i].price,
            };
            // console.log($data)
            this.rows.push($data);
          }
        });
    },
    getVendor() {
      this.$http.get("procurement/vendors").then((response) => {
        // console.log(response.data.data)
        this.form.optionsVendor.push({ value: null, text: "Select 1 Vendor" });

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsVendor.push($data);
        }
        // console.log(this.form.optionsVendor)
      });
    },
    getProduct() {
      this.$http.get("products").then((response) => {
        // console.log(response.data.data)
        this.form2.optionsProduct.push({
          value: null,
          text: "Select 1 Product",
        });

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          const { baseUrl } = $themeConfig.app;
          this.photo = baseUrl;
          this.photo += "storage/product/";
          this.photo += datas[i].image;

          var $data = {
            value: datas[i].id,
            text: datas[i].name,
            code: datas[i].code,
            unit: datas[i].unit_name,
            urlImage: this.photo,
          };
          // console.log($data)
          this.form2.optionsProduct.push($data);
        }
        // console.log(this.form2.optionsProduct)
      });
    },
    getTermPayment() {
      this.$http.get("procurement/term-payments").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.process.optionsTermPayment.push($data);
        }
        // console.log(this.process.optionsTermPayment)
      });
    },
    openItemDetails(id) {
      this.$http.get("procurement/purchase/item/" + id).then((response) => {
        // console.log(response.data.data)
        const { baseUrl } = $themeConfig.app;
        this.detail.product_image = baseUrl;
        this.detail.product_image += "storage/product/";
        this.detail.product_image += response.data.data.product_image;
        this.detail.id = response.data.data.id;
        this.detail.product_id = response.data.data.product_id;
        this.detail.purchase_code = response.data.data.purchase_code;
        this.detail.product_name = response.data.data.product_name;
        this.detail.qty = response.data.data.qty;
        this.detail.price = response.data.data.price;
        this.detail.purchase_id = response.data.data.purchase_id;
      });
    },
    link(url) {
      window.open(url);
    },
    triggerTax($data) {
      var newTax = $data;
      newTax = newTax.replace(/\,/g, "");
      var newAdditionalCost = this.form.additional_cost;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      this.form.total_price =
        this.form.defaultTotalPrice +
        parseInt(newTax) +
        parseInt(newAdditionalCost);
    },
    triggerAdditionalCost($data) {
      var newAdditionalCost = $data;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      var newTax = this.form.tax;
      newTax = newTax.replace(/\,/g, "");
      this.form.total_price =
        this.form.defaultTotalPrice +
        parseInt(newTax) +
        parseInt(newAdditionalCost);
    },
    submitStatus() {
      const id = this.$route.params.id;
      this.$http
        .post("procurement/purchase/" + id + "/status", {
          status: 1,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Data has been submited",
              variant: "success",
            },
          });
          location.href = "/procurement/purchase";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    checkProcess() {
      if (this.process.amount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Amount field is required",
            variant: "warning",
          },
        });
      } else if (this.process.selectedTermPayment === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Term Payment field is required",
            variant: "warning",
          },
        });
      } else {
        this.processPurchase();
      }
    },
    processPurchase() {
      const id = this.$route.params.id;
      var newAmount = this.process.amount;
      newAmount = newAmount.replace(/\,/g, "");
      if (this.process.selectedTermPayment !== null) {
        var $termPayment = this.process.selectedTermPayment.value;
      }
      this.$http
        .post("procurement/purchase/" + id + "/process", {
          amount: newAmount,
          term_payment: $termPayment,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Purchase Processed",
              variant: "success",
            },
          });
          location.href = "/procurement/purchase";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    statusReceive() {
      const $id = this.$route.params.id;
      sessionStorage.setItem("purchaseID", $id);
      this.$router.push({ name: "create-receiving", params: { id: $id } });
    },
    validation() {
      if (this.form.selectedVendor === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Vendor field is required",
            variant: "warning",
          },
        });
      } else if (this.form.total_price === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Total Price field is required",
            variant: "warning",
          },
        });
      } else if (this.form.tax === null || this.form.tax === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Tax field is required",
            variant: "warning",
          },
        });
      } else if (
        this.form.additional_cost === null ||
        this.form.additional_cost === ""
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Additional Cost field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.form.shipping_address === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Shipping Address field is required",
            variant: "warning",
          },
        });
      } else if (this.form.shipping_date === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Shipping Date field is required",
            variant: "warning",
          },
        });
      } else {
        this.updatePurchase();
      }
    },
    updatePurchase() {
      var newTotalPrice = this.form.total_price;
      newTotalPrice = newTotalPrice.replace(/\,/g, "");
      var newTax = this.form.tax;
      newTax = newTax.replace(/\,/g, "");
      var newAdditionalCost = this.form.additional_cost;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      let formData = new FormData();
      formData.append("vendor_id", this.form.selectedVendor.value);
      formData.append("total_price", newTotalPrice);
      formData.append("tax", newTax);
      formData.append("additional_cost", newAdditionalCost);
      formData.append("description", this.form.description);
      formData.append("shipping_address", this.form.shipping_address);
      formData.append("shipping_date", this.form.shipping_date);
      const id = this.$route.params.id;
      this.$http
        .post("procurement/purchase/" + id + "/update", formData)
        .then((response) => {
          // console.log(response.data.data)
          location.href = "/procurement/purchase";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deletePurchase() {
      const id = this.$route.params.id;
      this.$http
        .post("procurement/purchase/" + id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Purchase has been Deleted",
              variant: "danger",
            },
          });
          location.href = "/procurement/purchase";
          console.log(response.data.data);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>